<template>
  <div v-if="options && options.length > 0" class="inline-flex flex-col gap-0.5">
    <label v-if="label" class="text-xs font-semibold">
      {{ label }}
    </label>
    <div class="flex bg-gray-100 rounded-lg p-1" role="tablist">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        role="tab"
        :aria-selected="modelValue === option.value"
        :class="[
          'px-3 py-1 text-sm font-medium rounded-md transition-colors',
          modelValue === option.value
            ? 'bg-white shadow-sm text-gray-900'
            : 'text-gray-600 hover:text-gray-900'
        ]"
        @click="select(option)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterTabs',
  props: {
    label: {
      type: String,
      default: null
    },
    modelValue: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
      // Each item: { value, label }
    }
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    select(option) {
      this.$emit('update:modelValue', option.value);
      this.$emit('change', option.value);
    }
  }
};
</script>
